import React, { useState, useRef, useEffect } from 'react';
import { useForm } from "react-hook-form";
import {
    DialogContent, DialogTitle, Dialog,
    Paper, TextField, Box, Grid, TableCell, TableContainer, Typography,
    Table, TableHead, Button, IconButton, FormControl,
    InputLabel, TableRow, TableBody, Select, MenuItem, Input, Radio, RadioGroup, Card, Snackbar, Tooltip, Autocomplete,
} from '@mui/material';

import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import axios from 'axios'
import SaveIcon from '@mui/icons-material/Save';   
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { ERPinput, ERPinputNo } from '../../reusableComponent/ErpTextField';
import { UploadFileAttachment, addCompany, editDeleteCompany, getStateList } from '../../../actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { dateConversionOnEntryPage } from '../../reusableComponent/dateConversionOnEntryPage';
import { makeStyles } from '@mui/styles';
import styles from '.././../../styles.module.css';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px', // Set the desired font size
    },
});


function CompanyDetails(props) {
    const classes = useStyles();
    // const editData = props.details;
    const urlLocation = useLocation();
    const editData = urlLocation.state;
    const { handleSubmit } = useForm();
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const [selectState, setSelectState] = useState([]);
    let navigate = useNavigate();
    const location = useLocation();

    const editid = editData && editData.id;
    const [successMessage, setSuccessMessage] = useState(null);
    const [financialYear, setFinancialYear] = useState(editData ? editData.financialYear : 'April-March');
    const [logo_image, setImageName] = useState(editData ? editData.logo_image : '');
    const [imageFileName, setImageFileName] = useState('');
    const [openSnak, setOpenSnak] = React.useState(false);
    const [open, setOpen] = React.useState();
    const date_ob = new Date();
    const hours = date_ob.getHours();
    const minutes = date_ob.getMinutes();
    const seconds = date_ob.getSeconds();
    const milliseconds = date_ob.getMilliseconds();
    const currentTime = hours + ":" + minutes + ":" + seconds + ":" + milliseconds;

    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISODateTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
    const file_attachment = useSelector(state => state.customer_supplier_payment.fileAttachment)

    const [data, setData] = useState({
        id: editid,
        companyName: editData ? editData.companyName : '',
        address: editData ? editData.address : '',
        city: editData ? editData.city : '',
        pinCode: editData ? editData.pinCode : '',
        state: editid ? editData.state : '',
        gstIN: editData ? editData.gstIN : '',
        panNo: editData ? editData.panNo : '',
        logoHeight: editData ? editData.logoHeight : '',
        logoWidth: editData ? editData.logoWidth : '',
        companyDescription: editData ? editData.companyDescription : '',
        factoryAddress: editData ? editData.factoryAddress : '',
        currency: editData ? editData.currency : '₹',
        emailId: editData ? editData.emailId : '',
        mobileNo: editData ? editData.mobileNo : '',
    });

    const handleChangeuYear = (event) => {
        setFinancialYear(event.target.value);
    };

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }
    const [state, setState] = useState(editid ? editData.state : null);
    const stateList = useSelector(state => state.allStates.allStates)
    const handleChangeState = (event, newValue) => {
        setState(newValue)
    }

    const uploadFile = async (event) => {
        try {
          const selectedFile = event.target.files[0];
          const formData = new FormData();
          formData.append('file', selectedFile);
          await dispatch(UploadFileAttachment(formData));
        } catch (error) {
          console.error('Error uploading file:', error); // Log the error for debugging
        }
      };

    useEffect(() => {
        dispatch(getStateList())
        if (editid) {
            setState({
                name: editData.state,
            })
        }
    }, []);

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.company.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'User already available!') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);
    const onSubmit = (event) => {
        let companyData = {
            ...data,
            state: state.name,
            companyId: userInfo.companyId,
            financialYear: editData ? editData.financialYear : financialYear,
            logo_image: file_attachment == '' ? editData ? editData.logo_image : file_attachment : file_attachment,
            createdBy: editData ? editData.createdBy : userInfo.userId,
            createdAt: editData ? editData.createdAt : dateConversionOnEntryPage(new Date()),
            modifiedBy: editData ? userInfo.userId : null,
            modifiedAt: editData ? dateConversionOnEntryPage(new Date()) : '',
            changedUpdatedValue: 'edit',
        }
        if (editData) {
            dispatch(editDeleteCompany(companyData))
        } else {
            dispatch(addCompany(companyData))
        }
    }

    return (
        <>
            <div>
            <Breadcrumb
                            routeSegments={[
                                { name: 'Settings', path: '/settings' },
                                { name: 'Company Details List', path: '/company-details' },
                                { name: 'Create Company Details' },
                            ]}
                        />
            <Paper className={`${styles.list_container}`}>
                 
                     <Box sx={{ m: 0}} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2} style={{ paddingLeft: '50px', marginTop: 0, position: 'relative' }} >
                            <Grid item xs={4} >
                                <Grid container spacing={1} sx={{ mt: 0, }}>
                                    <Grid item xs={12}  >
                                        <Typography sx={{ fontWeight: 'bold' }}> Company Details Entry</Typography>
                                        <Typography className={`${styles.erp_lable}`}> Create Company details for registration for the Software.
                                            <br /> Enter Company description for printing in the invoice</Typography>
                                    </Grid>
                                    <Grid container style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', minWidth: '100%' }}>
                                        <Grid item xs={1} >
                                            <Typography className={`${styles.erp_lable}`} style={{ paddingLeft: '15px' }}>Financial Year</Typography>
                                        </Grid>
                                        <Grid item xs={11} >
                                            <ERPinput
                                                style={{ minWidth: '23%', paddingLeft: '5px' }}
                                                select
                                                name="financialYear"
                                                value={(financialYear)}
                                                size='small'
                                                onChange={handleChangeuYear}
                                                disabled={editid ? true : false}
                                            >
                                                <MenuItem className={`${styles.erp_lable}`} value="April-March">April-March</MenuItem>
                                                <MenuItem className={`${styles.erp_lable}`} value="January-December">January-December</MenuItem>
                                                <MenuItem className={`${styles.erp_lable}`} value="September-August">September-August</MenuItem>
                                            </ERPinput>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={2} ></Grid>
                            <Grid item xs={6} style={{ borderLeft: '1px solid #A9A9A9' }}>
                                <Grid container spacing={1} sx={{ mt: 1 }}>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>Company Name</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={handleChange}
                                            name="companyName"
                                            value={data.companyName}
                                            InputProps={{
                                                readOnly: userInfo.userRole == 'superAdmin' ? false : true,
                                            }}
                                            disabled={userInfo.userRole == 'superAdmin' ? false : true}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>Company Description</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <ERPinput
                                            multiline
                                            maxRows={2}
                                            inputProps={{
                                                maxLength: 200,
                                            }}
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={handleChange}
                                            name="companyDescription"
                                            value={(data.companyDescription)}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>Address</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={handleChange}
                                            name="address"
                                            value={data.address}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>Email Id</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={handleChange}
                                            name="emailId"
                                            value={(data.emailId)}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>Mobile No</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={handleChange}
                                            name="mobileNo"
                                            value={(data.mobileNo)}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>City</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={handleChange}
                                            name="city"
                                            value={(data.city)}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>Pin Code</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={handleChange}
                                            name="pinCode"
                                            value={(data.pinCode)}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>State</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <Autocomplete
                                            fullWidth
                                            classes={{
                                                option: classes.option,
                                            }}
                                            noOptionsText={
                                                <span className={classes.noOptionsLabel}>No options</span>
                                            }
                                            options={stateList}
                                            value={state}
                                            onChange={handleChangeState}
                                            getOptionLabel={(option) => option.name}
                                            getOptionSelected={(option, value) => option.name === value.name}
                                            renderInput={(params) => <ERPinput  {...params} />}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>Factory Address</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={handleChange}
                                            name="factoryAddress"
                                            value={data.factoryAddress}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>GST No</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={handleChange}
                                            name="gstIN"
                                            value={(data.gstIN)} />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>PAN No</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={handleChange}
                                            name="panNo"
                                            value={(data.panNo)}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>Company Logo</Typography>
                                    </Grid>

                                    <Grid item xs={9}>
                                        <div style={{ display: 'flex' }}>
                                            <ERPinput
                                                variant="standard"
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                accept="image/*" name="logo_image" id="contained-button-file" type="file"
                                                onChange={uploadFile} style={{ width: '90%', }} />

                                            <label htmlFor="contained-button-file">
                                                <Box style={{ width: '10%' }}>
                                                    <Box sx={{ border: '1px dotted #BEBEBE', marginLeft: '20px', marginTop: '3px', width: '26px', height: '26px', display: 'flex' }}>
                                                        <img src={logo_image} style={{ width: '20px', height: '20px', margin: '2px' }} />
                                                    </Box>
                                                </Box>
                                            </label>
                                        </div>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>Logo Height</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <ERPinputNo
                                            size='small'
                                            fullWidth
                                            type="number"
                                            onChange={handleChange}
                                            name="logoHeight"
                                            value={(data.logoHeight)}
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>Logo Width</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <ERPinputNo
                                            size='small'
                                            fullWidth
                                            type="number"
                                            onChange={handleChange}
                                            name="logoWidth"
                                            value={(data.logoWidth)}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography className={`${styles.erp_lable}`}>Currency</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                            <ERPinput
                                                select
                                                name="currency"
                                                value={data.currency}
                                                size='small'
                                                onChange={handleChange}
                                                required
                                                fullWidth
                                            >
                                                <MenuItem className={`${styles.erp_lable}`} value="₹">Indian Rupee (₹)</MenuItem>
                                                <MenuItem className={`${styles.erp_lable}`} value="$">United States Dollar ($)</MenuItem>
                                                <MenuItem className={`${styles.erp_lable}`} value="€">Euro (€)</MenuItem>
                                                <MenuItem className={`${styles.erp_lable}`} value="₽">Russian Ruble (₽)</MenuItem>
                                                <MenuItem className={`${styles.erp_lable}`} value="¥">Japanese Yen (¥)</MenuItem>
                                                <MenuItem className={`${styles.erp_lable}`} value="£">British Pound (£)</MenuItem>
                                            </ERPinput>
                                    </Grid>
                                    
                                    <Grid item md={12}>
                                            <Box sx={{ marginTop: '12px', float: 'right' }}>
                                                <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                                <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                                                </Button>
                                                <Cancel />
                                            </Box>
                                        </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    
                    </form>
                </Paper>
            </div>
            {successMessage &&
                    <Snackbar
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        open={successMessage}
                        autoHideDuration={2000}
                        message={successMessage}
                    />
                }
        </>
    )
}

export default CompanyDetails;